import { styled } from "@material-ui/core/styles";
import { MOBILE_BREAKPOINT } from "../../constants";

const BottomLeftContent = styled("div")(({ theme }) => ({
  display: "flex",
  position: "absolute",
  bottom: 0,
  left: 0,
  pointerEvents: "none",
  "& a": {
    pointerEvents: "all",
    "&:not(:first-child)": {
      marginLeft: theme.spacing(2)
    }
  },
  margin: "3rem",
  [theme.breakpoints.down(`md`)]: {
    margin: theme.spacing(3)
  },
  [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
    margin: theme.spacing(3)
  },
  "@media (max-width: 320px)": {
    margin: theme.spacing(2, 1)
  }
}));

export default BottomLeftContent;
